import { Injectable } from '@angular/core';
import Shepherd from 'shepherd.js';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class TourService {

  private tour !: Shepherd.Tour;

  constructor(
    private translate: TranslateService
  ) {
    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        scrollTo: { behavior: 'smooth', block: 'center' },
        classes: 'shepherd-theme-arrows',
      }
    });
  }

  startTour() {
    const rawSteps = [
      {
        id: 'step-one',
        title: '<h3>Side Menu</h3>',
        text: this.translate.instant('tour_step_one'),
        elementClass: '.dynamic-menu',
      },
      {
        id: 'step-two',
        title: '<h3>24/7 Prayer</h3>',
        text: this.translate.instant('tour_step_two'),
        elementClass: '.global-prayer-btn',
      },
      {
        id: 'step-three',
        title: '<h3>Pray for all</h3>',
        text: this.translate.instant('tour_step_three'),
        elementClass: '.pray-for-all-btn',
      },
      {
        id: 'step-four',
        title: '<h3>Prayer rooms</h3>',
        text: this.translate.instant('tour_step_four'),
        elementClass: '.prayer-rooms-btn',
      },
      {
        id: 'step-five',
        title: '<h3>Giving</h3>',
        text: this.translate.instant('tour_step_five'),
        elementClass: '.giving-btn',
      }
    ];
  
    const totalSteps = rawSteps.length;
  
    const steps : any = rawSteps.map((step, index) => {
      const current = index + 1;
      const progressPercent = Math.floor((current / totalSteps) * 100);
    
      return {
        id: step.id,
        title: step.title,
        text: `
          <div>${step.text}</div>
          <br>
          <div class="tour-progress-bar-wrapper">
            <div class="tour-progress-bar" style="width: ${progressPercent}%;"></div>
          </div>
        `,
        attachTo: {
          element: step.elementClass,
          on: 'bottom'
        },
        scrollTo: true,
        buttons: [
          ...(index > 0 ? [{
            text: 'Back',
            action: this.tour.back,
            classes: 'shepherd-button-secondary'
          }] : []),
          ...(index < totalSteps - 1 ? [{
            text: 'Next',
            action: this.tour.next
          }] : [{
            text: 'Finish',
            action: this.tour.complete
          }])
        ]
      };
    });
  
    this.tour.addSteps(steps);
    this.tour.start();
  }
}
